import { Outlet, useLoaderData, useLocation } from "react-router-dom";
import SideBar from "./Components/Sidebar/SideBar";
import { useContext, useEffect, useRef } from "react";
import { sidebarDisabledRoutes } from "./Utils/routes";
import { useDispatch, useSelector } from "react-redux";
import {
  updateAuthenticationState,
  updateLoadingStates,
} from "./Store/Slices/authStates";
import { add } from "./Store/Slices/user";
import Header from "./Components/Header/Header";
import useFetchIndustries from "./Hooks/useFetchIndustries";
import SettingSection from "./Sections/SettingSection";
import { ShowProfileContext } from "./Contexts/showProfileContext";
import { SmallSignUpContext } from "./Contexts/smallSignUpContext";
import SmallSignUp from "./Components/Auth/SmallSignUp";
import ReportIssue from "./Components/ReportIssue/ReportIssue";

function App() {
  const dispatch = useDispatch();
  const data = useLoaderData();
  // console.log("data from useloader", data);
  let location = useLocation()?.pathname.split("/")?.[1];

  const isAuthenticated = useSelector(
    (state) => state.authStates?.isUserAuthenticated,
  );
  useFetchIndustries(isAuthenticated);

  useEffect(() => {
    let cancelled = false;

    const initializeAuth = async () => {
      try {
        if (data?.success && data?.data) {
          dispatch(add(data.data));
          dispatch(updateAuthenticationState(true));
          return;
        }

        const { USER_PROFILE_GETTER } = await import("./Utils/apis");

        const response = await fetch(USER_PROFILE_GETTER, {
          method: "GET",
          credentials: "include",
        });

        if (cancelled) return;

        if (!response.ok) {
          dispatch(updateAuthenticationState(false));
          return;
        }

        const result = await response.json();

        if (cancelled) return;

        if (result?.data) {
          dispatch(add(result.data));
          dispatch(updateAuthenticationState(true));
        } else {
          dispatch(updateAuthenticationState(false));
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Authentication initialization failed:", error);
          dispatch(updateAuthenticationState(false));
        }
      } finally {
        if (!cancelled) {
          dispatch(updateLoadingStates(false));
        }
      }
    };

    dispatch(updateLoadingStates(true));
    initializeAuth();

    return () => {
      cancelled = true;
    };
  }, [data, dispatch]);

  const headerDisabledRoutes = ["auth", "interview"];
  const headerRef = useRef();
  const sidebarRef = useRef();

  const { showProfilePopUp, closeProfile } = useContext(ShowProfileContext);
  const { showPopUp: SignUpPopUp, setShowPopUp: setSignUpPopUp } =
    useContext(SmallSignUpContext);

  // useEffect(()=>{
  //   window.addEventListener('beforeunload', (e)=>{e.preventDefault(); alert('ohoh trying to refres, just click here first then reload.')})

  // },[])
  const candidateId = useSelector((state) => state.user?.candidate_id);
  const isLoading = useSelector((state) => state.authStates?.loading);
  // console.log("candidate id", candidateId);
  return (
    <div className="flex w-screen h-screen App bg-main-bg ">
      {SignUpPopUp && <SmallSignUp />}
      {showProfilePopUp && <SettingSection closeProfile={closeProfile} />}
      <ReportIssue />
      {!isLoading && !sidebarDisabledRoutes.includes(location) && candidateId && (<SideBar ref={sidebarRef} />)}
      <div className={`flex-1 `}>
        {!isLoading && !headerDisabledRoutes.includes(location) && (
          <Header ref={headerRef} />
        )}
        <div
          className={` ${!headerDisabledRoutes.includes(location) && "px-2 lg:px-4 md:pr-4 lg:pr-16 pt-4 pb-44 lg:pb-24"} h-full overflow-auto fixed w-full `}
        >
          {/* { hight full is required here for child to get parent height} */}
          <Outlet />
        </div>
      </div>
    </div>
  );
}
export default App;
